// src/hooks/api/openbinapi.js

const fetchBINData = async (bin) => {
    try {
      const response = await fetch(`https://openbinapi.com/api/v1/bin/${bin}`);
      if (!response.ok) throw new Error("Ошибка загрузки BIN данных");
      const data = await response.json();
      console.log("OpenBIN response data:", data);
      return data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  
  export default fetchBINData;